module.exports = __webpack_public_path__ + "static/media/Groupsuccess.302d44b9.svg";